namespace app.upgraded {
    "use strict";

    import IStateService = angular.ui.IStateService;
    
    export class UpgradedController {

        public currentStateChangeRequest;
        
        public hide: boolean = true;

        public parentUrl: string;

        public frameUrl: string;

        public ts: number;

        /** @ngInject **/
        constructor(private upgradedCommunicationService: UpgradedCommunicationService,
                private $window: ng.IWindowService, private $rootScope: angular.IRootScopeService,
                private $sce: ng.ISCEService, private $timeout: angular.ITimeoutService,
                private $stateParams: angular.ui.IStateParamsService,
                private $state: angular.ui.IStateService,
                private properties: app.support.constants.Properties) {
            this.parentUrl = this.$window.location.origin;

            this.updateTS();
            if ($state.current.name === "app.upgraded") {
                this.frameUrl = $sce.trustAsResourceUrl(`${this.properties.upgradedUrl}${$state.params["url"]}?ts=${this.ts}`); // Carrega a UI2 inicialmente na rota vazia.
                this.hide = false;
            } else {
                if (this.properties.upgradedLoadStrategy === "eager") { // Eager
                    this.frameUrl = $sce.trustAsResourceUrl(`${this.properties.upgradedUrl}empty?ts=${this.ts}`); // Carrega a UI2 inicialmente na rota vazia.
                }
            }
                    
            this.currentStateChangeRequest = this.upgradedCommunicationService.getCurrentStateChangeRequest();
            $rootScope.$on('$stateChangeStart', (event, toState, toParams, fromState, fromParams, options) => { 
                // Exibe ou esconde a view upgraded a depender se a rota que foi acessada é upgraded ou não.
                if (toState.name === "app.upgraded") {
                    this.hide = false;
                } else {
                    this.hide = true;
                }
            });
            $rootScope.$on('upgraded:frame-url-changed', (event, newUrl) => {
                this.updateTS();
                this.frameUrl = $sce.trustAsResourceUrl(`${this.properties.upgradedUrl}${newUrl}?ts=${this.ts}`); // Carrega a UI2 inicialmente na rota vazia.
            });
        }

        private updateTS() {
            this.ts = new Date().getTime();
        }
    }

    angular
        .module('app.upgraded')
        .controller('app.upgraded.UpgradedController', UpgradedController);
}